import { Comparison, CredentialType } from '@uac-au/advance-typings';

import { RequiredCredential } from 'types/required-credential';
import { SourceInstitution } from 'types/source-institution';

/**
 * Extracts an appropriate Source Institution ID from
 * a Required Credential's matching criteria. *
 * @export
 * @param {RequiredCredential} requiredCredential
 * @return {*}  {(string | undefined)}
 */
export function extractSourceInstitutionID(requiredCredential: RequiredCredential): string | undefined {
  switch (requiredCredential.type) {
    case CredentialType.EMPLOYMENT: {
      const foundCompany = requiredCredential.matchingCriteria.find(
        (match) => match.field === 'company' && match.comparison === Comparison.EQUAL_TO,
      );
      return foundCompany?.value;
    }
    default: {
      // @ts-expect-error: typing issue with credential.type union type
      const foundInstitutionCode = requiredCredential.matchingCriteria.find(
        (match: { field: string; comparison: Comparison }) =>
          match.field === 'institutionCode' && match.comparison === Comparison.EQUAL_TO,
      );
      return foundInstitutionCode?.value;
    }
  }
}

/**
 * Extracts an appropriate Source Institution Name from
 * a Required Credential's matching criteria.
 * @export
 * @param {RequiredCredential} requiredCredential
 * @return {*}  {(string | undefined)}
 */
export function extractSourceInstitutionName(
  requiredCredential: RequiredCredential,
  sourceInstitutions: Map<string, SourceInstitution>,
): string | undefined {
  switch (requiredCredential.type) {
    case CredentialType.EMPLOYMENT: {
      const foundCompany = requiredCredential.matchingCriteria.find(
        (match) => match.field === 'company' && match.comparison === Comparison.EQUAL_TO,
      );
      return foundCompany?.value;
    }
    default: {
      // @ts-expect-error: typing issue with credential.type union type
      const foundInstitutionName = requiredCredential.matchingCriteria.find(
        (match: { field: string; comparison: Comparison }) =>
          match.field === 'institutionName' && match.comparison === Comparison.EQUAL_TO,
      );
      // @ts-expect-error: typing issue with credential.type union type
      const foundInstitutionCode = requiredCredential.matchingCriteria.find(
        (match: { field: string; comparison: Comparison }) =>
          match.field === 'institutionCode' && match.comparison === Comparison.EQUAL_TO,
      );
      return (
        foundInstitutionName?.value ??
        sourceInstitutions.get(foundInstitutionCode?.value)?.name ??
        foundInstitutionCode?.value
      );
    }
  }
}
